// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-manager-table thead th .relative {
  padding: 10px 4px !important;
}

.list-manager-table .handsontable-container .ht_clone_top {
  border-bottom: none !important;
}

.list-manager-table .ht_clone_top_left_corner {
  border-bottom: none !important;
}

.list-manager-table .wtHolder {
  border-top: 1px solid #ccc;
}

.list-manager-table .handsontable thead th {
  border-top: none;
}
`, "",{"version":3,"sources":["webpack://./admin/template-elements/lists-manager/list-manager.global.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".list-manager-table thead th .relative {\n  padding: 10px 4px !important;\n}\n\n.list-manager-table .handsontable-container .ht_clone_top {\n  border-bottom: none !important;\n}\n\n.list-manager-table .ht_clone_top_left_corner {\n  border-bottom: none !important;\n}\n\n.list-manager-table .wtHolder {\n  border-top: 1px solid #ccc;\n}\n\n.list-manager-table .handsontable thead th {\n  border-top: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
